import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'era-device-scheduled-tasks-cancel-ui',
  templateUrl: './device-scheduled-tasks-cancel.component.html',
  styleUrls: ['./device-scheduled-tasks-cancel.component.scss'],
})
export class DeviceScheduledTasksCancelComponent {
  @Output() public readonly cancelled = new EventEmitter<void>();

  public onCancel() {
    this.cancelled.emit();
  }
}
